import React, { useState } from 'react';
import { useLanguage } from '../../../../../../../hooks/useLanguage';
import { pos as frPos } from '../../../../../../../locales/fr/pos';
import { pos as esPos } from '../../../../../../../locales/es/pos';
import { pos as arPos } from '../../../../../../../locales/ar/pos';

const translations = {
  fr: frPos,
  es: esPos,
  ar: arPos
};

const VirtualKeypad = ({ 
  onValueChange, 
  onEnter, 
  selectedLineIndex,
  currentCommande,
  clearCurrentCommande 
}) => {
  const { lang } = useLanguage();
  const t = translations[lang] || translations.fr;
  
  const [displayValue, setDisplayValue] = useState('');

  const handleNumberClick = (number) => {
    setDisplayValue(prev => prev + number);
    onValueChange?.(displayValue + number);
  };

  const handleDecimalClick = () => {
    if (!displayValue.includes('.')) {
      setDisplayValue(prev => prev + '.');
      onValueChange?.(displayValue + '.');
    }
  };

  const handleClear = () => {
    setDisplayValue('');
    onValueChange?.('');
  };

  const handleBackspace = () => {
    setDisplayValue(prev => prev.slice(0, -1));
    onValueChange?.(displayValue.slice(0, -1));
  };

  const handleEnter = () => {
    onEnter?.(displayValue);
    setDisplayValue('');
  };

  const handleSelectorClick = (type) => {
    console.log(`Sélecteur ${type} cliqué`);
    // TODO: Implémenter la logique pour éditer la ligne courante dans le panier
  };

  const handleToggleSign = () => {
    console.log('Changement de signe +/-');
    // TODO: Implémenter la logique pour changer le sens de l'opération
  };

  const handleClearCart = () => {
    if (window.confirm(t.virtualKeypad.clearCartConfirm)) {
      clearCurrentCommande?.();
    }
  };

  const keypadButtons = [
    { label: '1', action: () => handleNumberClick('1') },
    { label: '2', action: () => handleNumberClick('2') },
    { label: '3', action: () => handleNumberClick('3') },
    { label: '4', action: () => handleNumberClick('4') },
    { label: '5', action: () => handleNumberClick('5') },
    { label: '6', action: () => handleNumberClick('6') },
    { label: '7', action: () => handleNumberClick('7') },
    { label: '8', action: () => handleNumberClick('8') },
    { label: '9', action: () => handleNumberClick('9') },
    { label: t.virtualKeypad.buttons.toggleSign, action: handleToggleSign, className: 'bg-purple-500 hover:bg-purple-600 text-white' },
    { label: t.virtualKeypad.buttons.decimal, action: handleDecimalClick },
    { label: '0', action: () => handleNumberClick('0') },
    { label: t.virtualKeypad.buttons.backspace, action: handleBackspace, className: 'bg-gray-300 hover:bg-gray-400' },
  ];

  const selectorButtons = [
    { label: t.virtualKeypad.selectors.quantity, action: () => handleSelectorClick('quantity'), className: 'bg-blue-500 hover:bg-blue-600 text-white' },
    { label: t.virtualKeypad.selectors.discount, action: () => handleSelectorClick('discount'), className: 'bg-orange-500 hover:bg-orange-600 text-white' },
    { label: t.virtualKeypad.selectors.price, action: () => handleSelectorClick('price'), className: 'bg-green-500 hover:bg-green-600 text-white' },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border h-full flex flex-col p-4">
      {/* Pavé numérique avec sélecteurs - 4 colonnes */}
      <div className="flex-1 grid grid-cols-4 gap-2">
        {/* Colonnes 1-3: Pavé numérique */}
        <div className="col-span-3 grid grid-cols-3 gap-2">
          {keypadButtons.map((button, index) => (
            <button
              key={index}
              onClick={button.action}
              className={`text-lg font-semibold rounded-lg transition-colors ${
                button.className || 'bg-gray-200 hover:bg-gray-300 text-gray-800'
              }`}
            >
              {button.label}
            </button>
          ))}
          {/* Bouton Vider en dessous de . et 0 */}
          <div className="col-span-2">
            <button
              onClick={handleClearCart}
              className="w-full bg-red-500 py-2 mt-2 hover:bg-red-600 text-white text-sm font-semibold rounded-lg transition-colors"
            >
              {t.virtualKeypad.clearCart}
            </button>
          </div>
        </div>
        
        {/* Colonne 4: Sélecteurs */}
        <div className="col-span-1 grid grid-rows-3 gap-2">
          {selectorButtons.map((button, index) => (
            <button
              key={index}
              onClick={button.action}
              className={`text-sm font-semibold rounded-lg transition-colors ${
                button.className
              }`}
            >
              {button.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VirtualKeypad; 